import type { UnknownRecord } from "@/utils/type";

import { ApplicationError } from "./ApplicationError";

// Throw this when an action should be cancelled (e.g. due to no network, page reloading)
// and no useful data can be returned to the caller, but the error should NOT be logged.
export class CancelError extends ApplicationError {
  constructor(message: string, cause: UnknownRecord = {}) {
    super("CancelError", message, { cause });
  }
}
